import { formatDate } from '../../../../../utils/date-fns'

const ISO_DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/

const parseFecDate = (value: string): Date | undefined => {
  const isoDateMatch = ISO_DATE_PREFIX.exec(value)

  if (isoDateMatch) {
    return new Date(Number(isoDateMatch[1]), Number(isoDateMatch[2]) - 1, Number(isoDateMatch[3]))
  }

  const date = new Date(value)

  return Number.isNaN(date.getTime()) ? undefined : date
}

export const formatFecImportPeriod = (
  periodStart?: string | null,
  periodEnd?: string | null,
  locale?: string,
): string | undefined => {
  if (!periodStart || !periodEnd) {
    return
  }

  const startDate = parseFecDate(periodStart)
  const endDate = parseFecDate(periodEnd)

  if (!startDate || !endDate) {
    return
  }

  const startMonth = formatDate(startDate, 'MMM', locale)
  const endMonth = formatDate(endDate, 'MMM', locale)
  const startYear = startDate.getFullYear()
  const endYear = endDate.getFullYear()

  if (startYear === endYear) {
    return `${startMonth}–${endMonth} ${endYear}`
  }

  return `${startMonth} ${startYear} — ${endMonth} ${endYear}`
}
